export interface ItemListFields {
  item_list_id: string;
  item_list_name: string;
}

export interface ItemListGroup extends ItemListFields {
  items: Record<string, unknown>[];
}

/** GA4 rejects an event whose `items` array exceeds 200 entries. */
const GA4_ITEMS_PER_EVENT = 200;

export const groupByItemList = (
  queue: Record<string, unknown>[],
): ItemListGroup[] => {
  const groups = new Map<string, ItemListGroup>();

  for (const item of queue) {
    const id = String(item.item_list_id ?? '');
    const group = groups.get(id) ?? {
      item_list_id: id,
      item_list_name: String(item.item_list_name ?? ''),
      items: [],
    };
    group.items.push(item);
    groups.set(id, group);
  }

  return [...groups.values()];
};

const chunk = <T>(items: T[], size: number): T[][] => {
  const chunks: T[][] = [];
  for (let i = 0; i < items.length; i += size) {
    chunks.push(items.slice(i, i + size));
  }
  return chunks;
};

export const toItemListViews = (
  queue: Record<string, unknown>[],
): Record<string, unknown>[] =>
  groupByItemList(queue).flatMap(({ item_list_id, item_list_name, items }) =>
    chunk(items, GA4_ITEMS_PER_EVENT).map((part) => ({
      item_list_id,
      item_list_name,
      items: part,
    })),
  );
